<template>
	<div id="applyList">
		<!--<div class="apply-box">-->
		<div v-title>我的售后</div>
		<scroller v-if='isEmpty' height="95%" :on-infinite="infinite" style="padding-bottom:30px" :on-refresh="refresh" refreshText="" ref="myscroller" noDataText="- 没有更多数据了 -">
			<div>
				<div class="apply-item" v-for="item in totalList">
					<div class="title-wrap">
						<div class="apply-title">
							<div class="title-time">
								<p class="apply-time">申请时间:&nbsp;<span>{{item.createTime}}</span></p>
								<p class="order-time">{{item.receiveTime}}&nbsp;<span>{{item.receiveWeek}}</span></p>
							</div>
							<span class="apply-type">{{item.status | formatStatus}}</span>
						</div>
					</div>
					<div class="apply-con">
						<p class="goods-title">{{item.productName}}</p>
						<p class="problem-label">{{item.afterType | formatAfterType}}</p>
						<p class="problem-box">
							<span class="problem-item" v-for="item1 in item.problemArr">{{item1}}</span>
						</p>
					</div>
					<div class="de-box clearfix">
						<div class="look-btn" @click="toDetail(item)">查看详情</div>
					</div>
				</div>
			</div>

		</scroller>
		<div class="list-empty" v-else>
			<img src="https://misc.reflower.com.cn/images/order/hint-app.png" />
			<p>没有正在售后的订单 </p>
		</div>
		<div class="submit-box">
			<div class="submit" @click="toApplySer" >申请售后</div>
		</div>
		<!--<div class="submit" @click="toApplySer">申请售后</div>-->
		<!--</div>-->
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueScroller from 'vue-scroller'
	import '../../static/lib/layer.js'
	Vue.use(VueScroller)
	export default {
		data() {
			return {
				offset: 0,
				limit: 10,
				totalList: [],
				isEmpty: true,
				user: {},
        timestamp: ''
			}
		},
		created() {
//			this.chkLogin();
			this.getUserInfo();
			//			this.getApplyList();
		},
		methods: {
			getApplyList: function(offset, done) {
				let hdu = this.getCookie('hdu');

				let param = {
					pageNumber: this.offset,
					pageSize: this.limit,
					userId: hdu,
					openid: this.user.openid
				};
				this.http({
					url: this.applyList,
					method: 'post',
					data: param
				}).then(res => {
					if(res.data.httpCode == 200) {
						let list = res.data.data;
            this.timestamp = res.data.timestamp;
						if(list.length > 0) {
							list.forEach(item => {
								item.problemArr= item.problemType.split(',')
								this.totalList.push(item)
							})

						} else {
							if(this.totalList.length > 0) {
								let _this = this;
								setTimeout(() => {
									//没有数据了 执行 finishInfinite(2)
									_this.$refs.myscroller.finishInfinite(2);
								})
							} else {
								this.isEmpty = false;
							}
							return
						}

						//当前下拉加载结束之后，执行done方法，以便下一次下拉加载正常执行
						this.$refs.myscroller.finishPullToRefresh();
						if(res.data.httpCode == 200) {
							done();
						}

					} else {
						this.popUp(res.data.msg)
					}
				}).catch(err=>{
				})

			},

			infinite: function(done) {
				this.offset++;
				this.getApplyList(this.offset, done);
			},

			refresh: function(done) {
//				this.offset = 1;
//				this.getApplyList(1, done);
				window.location.reload()
			},

			//去申请
			toApplySer: function() {
				this.popUp('请于工作时间（10:00-19:00）联系公众号客服！')
				return
        // let date =this.timestamp!=""? new Date(Number(this.timestamp)) : '';
        // let h = date.getHours();
        // console.log(h,'date')
        // console.log(this.checkAuditTime('10:00', '19:00'))
        // if(this.checkAuditTime('10:00', '19:00')){
        //   this.popUp('为了更高效服务，每日工作时间（10：00-19：00）可在公众号聊天框里输入您的问题，由客服为您实时处理。')
        // }else{
        //   this.$router.push({
        //     path: '/applyServer'
        //   })
        // }

			},
      // 方法
    checkAuditTime: function(startTime, endTime){
          // 获取当前时间
          let date  = new Date()
          // 获取当前时间的年月日
          let dataStr = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} `
          dataStr = dataStr.replace(/-/g, "/")
          // 获取开始时间、结束时间、现在时间的时间戳
          let startDate = new Date(dataStr + startTime).getTime()
          let endDate = new Date(dataStr + endTime).getTime()
          let nowDate = date.getTime()

          let s = startDate > endDate // 判断开始时间否大于结束时间

          if(s) [startDate, endDate] = [endDate, startDate] // 若开始时间否大于结束时间则交换值

          // 判断现在的时间是否在开始时间和结束时间之间，若s为true则结果取反
          if(nowDate > startDate && nowDate < endDate){
              return s ? false : true
          }else{
              return s ? true : false
          }
      },
			//申请详情
			toDetail: function(val) {
				if(val.afterType=='1' && val.status!=1 && val.status!=2){
						this.$router.push({
						path: '/saleDetail',
						query: {
							formId: val.formId,
							status: val.status
						}
					})
				}else{
					this.$router.push({
						path: '/applyDetail',
						query: {
							formId: val.formId
						}
					})
				}
			},

			getCookie: function(name) { //获取cookie
				var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
				if(arr = document.cookie.match(reg)) {
					var data = unescape(arr[2]);
					return data;
				} else {
					return '';
				}
			},

			delCookie: function(name) { //删除cookie
				var exp = new Date();
				exp.setTime(exp.getTime() - 1);
				var cval = this.getCookie(name);
				console.log(this.getCookie(name))
				document.cookie = name + "=" + cval + ";path=/;domain=reflower.com.cn;expires=" + exp.toGMTString() + "";
				console.log(document.cookie)
			},

			chkLogin: function() {
				let uid = this.getCookie('hdu');
				let hdt = this.getCookie('hdt');
				let ua = navigator.userAgent.toLowerCase();
				let loginurl = this.loginurl;
				let wechaturl = this.wechaturl;
				let alipayurl = this.alipayurl;
				let alipayoauth2url = 'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2017021505685120&redirect_uri=';
				let oauth2url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx05d6a1410a2236e1&redirect_uri=';
        // let oauth2url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxaa2aa6cc330cd7bf&redirect_uri=';
				if(!!!uid || !!!hdt) {
					var currenturl = window.location.href;
					if(currenturl.indexOf('?') < 0) {
						currenturl += "?";
					} else {
						currenturl += "&";
					}
					if(ua.match(/MicroMessenger/i) == "micromessenger") {
						//   	console.log("wechaturl: "+wechaturl + "||| currenturl: "+currenturl );
						var redirectUrl = encodeURIComponent(wechaturl + currenturl);
						//   	console.log("redirectUrl"+redirectUrl);
						var resultUrl = oauth2url + redirectUrl + "&response_type=code&scope=snsapi_base&state=login#wechat_redirect";
						window.location.href = resultUrl;
					} else if(ua.indexOf("alipay") >= 0) {
						var redirectUrl = encodeURIComponent(alipayurl + currenturl);
						var resultUrl = alipayoauth2url + redirectUrl + "&scope=auth_user,auth_zhima";
						window.location.href = resultUrl;
					} else {
						window.location.href = loginurl + encodeURIComponent(currenturl);
					}
				}
			},
			//获取用户信息
			getUserInfo: function() {
				let _this = this;
				let uid = this.getCookie('hdu');
				let hdt = this.getCookie('hdt');
				$.ajax({
					url: _this.userInfo,
					type: 'post',
					async: false,
					type: 'post',
					xhrFields: {
						withCredentials: true
					},
					contentType: "application/json",
					crossDomain: true,
					dataType: "json",
					success: function(res) {
						if(res.code == 2000) {
							_this.user = res.data
						} else if(res.code == 1010) {
							_this.delCookie('hdu');
							_this.delCookie('hdt');
							if(!uid || !hdt) {
								_this.$router.push({
									path: '/'
								})
							}

						} else {
							_this.popUp(res.data.msg)
						}
					}
				});
			},
			popUp: function(content) {
				layer.open({
					content: content,
					skin: 'msg',
					time: 4 //2秒后自动关闭
				});
			},
		},


		filters: {
			formatStatus: function(value) {
				let val = '';
				switch(value) {
					case "1":
						val = "待领取"
						break;
					case "2":
						val = "处理中"
						break;
					case "3":
						val = "已完成"
						break;
					case "4":
						val = "已取消"
						break;
					case "5":
						val = "已关闭"
						break;
					case "21":
						val = "待用户寄回"
						break;
					case "22":
						val = "待商家收货"
						break;
					case "23":
						val = "商家已签收"
						break;
					case "24":
						val = "退款中"
						break;
					case "25":
						val = "商家拒收"
						break;
				}
				return val
			},
			formatAfterType(value){
				let str=""
				switch(value){
					case '1': str="退货退款"
					break;
					case '2': str="仅退款"
					break;
					case '0': str="其他"
					break
				}
				return str
			},
		}
	}
</script>

<style scoped>
	.apply-item {
		background-color: #FFFFFF;
		/*padding: 0 0.4rem;*/
		margin: 0.32rem 0.213333rem;
		position: relative;

	}
	.apply-item .title-wrap{
		padding: 0 0.24rem 0 0.373333rem;
		text-align: left;
	}
	.apply-item .apply-title {
		height: 1.253333rem;
		line-height: 1.253333rem;
		color: #999999;
		font-size: 0.32rem;
		/*text-align: left;*/
		display: flex;
		justify-content: space-between;
		/*padding: 0 0.4rem;*/
		border-bottom: 0.026666rem solid #EEEEEE;
	}
	.apply-title .apply-time{
		margin: 0.24rem 0 0.106666rem 0;
		line-height: 0.373333rem;
		font-size: 0.266666rem;
		color: #333333;
		font-weight: bold;
	}
	.apply-title .order-time{
		line-height: 0.373333rem;
		font-size: 0.266666rem;
	}

	.apply-item .apply-title .apply-type {
		font-size: 0.373333rem;
		color: #C4D275;
		font-weight: 700;
	}

	.problem-box .problem-item{
		display: inline-block;
		margin-right: 0.32rem;
		padding: 0.266666rem 0.373333rem;
		background: #F5F5F5;
		border-radius: 0.08rem;
		font-size: 0.266666rem;
		font-weight: bold;
		color: #666666;
	}
	.problem-label{
		font-size: 0.373333rem;
		color: #333333;
		font-weight: bold;
	}
	.apply-item .apply-con {
		/*height: 2.4rem;*/

		background-color: #FFFFFF;
		padding: 0.426666rem 0.4rem 0.453333rem 0.4rem;
		text-align: left;
	}

	.apply-item .apply-con .goods-title {
		margin-bottom: 0.426666rem;
		font-size: 0.373333rem;
		line-height: 0.533333rem;
		font-weight: bold;
		width: 9rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.apply-item .apply-con .order-time {
		font-size: 0.32rem;
		color: #999999;
		margin-top: 0.133333rem;
	}

	.submit-box{
		padding: 0 0.213333rem;
		width: 100%;
		height: 2rem;
		position: fixed;
		bottom: 0;
		left: 0;
		background: #f4f4f4;
		opacity: 1;
	}
	.submit {
		height: 1.306666rem;
		line-height: 1.306666rem;
		font-size: 0.48rem;
		color: #FFFFFF;
		background-color: #262628;
		border-radius: 0.16rem;
	}

	.de-box {
		/*width: 100%;
		height: 1.2rem;*/
		position: absolute;
		right: 0.24rem;
		bottom: 0.5rem;
	}

	.de-box .look-btn {
		width: 2.213333rem;
		height:0.8rem;
		border-radius: 0.4rem;
		color: #333333;
		border: 1px solid #E2E2E2;
		font-size: 0.346666rem;
		font-weight: bold;
		line-height: 0.8rem;
	}

	.clearfix:after {
		content: ".";
		display: block;
		clear: both;
		visibility: hidden;
		font-size: 0;
	}

	.list-empty {
		/*padding-top: 5.2rem;*/
		text-align: center;
	}

	.list-empty img {
		width: 4rem;
		height: 4rem;
		margin: 5.2rem 3.013333rem 0 3.013333rem;
		vertical-align: bottom;
	}

	.list-empty p {
		display: inline-block;
		width: 4.8rem;
		font-size: 0.4rem;
		color: #999999;
		line-height: 0.6rem;
	}

</style>



// WEBPACK FOOTER //
// src/path/applyList.vue